import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Collage from '../components/Collage';
import { doRestorePassword } from '../actions';




class ForgotPassword extends Component {

  componentWillMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.refs.email.checkValidity()) {
      this.props.doRestorePassword(this.refs.email.value);
    }
  }

  render() {

    return (
      <div className="forgot-content">
        <Collage />

        <div className="forgot-wrapper">
          <div className="forgot-title">Forgot your password?</div>
          <span>Enter your email address below and we'll send you instructions to reset your password</span>
          <form className="forgot-form" onSubmit={this.handleSubmit.bind(this)}>
            <input type="email" ref="email" placeholder="Enter your email address" />
            <input className="button button-primary" onClick={this.handleSubmit.bind(this)} type="submit" value="Send me reset instructions"/>
          </form>
        </div>
      </div>
    );
  }

};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doRestorePassword,
  }
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.jsx